import { useEffect, useState } from "react";
import { addData, loadData, updateData } from "../../../../config/data";
import { useDispatch, useSelector } from "react-redux";
import Lang from "../../../../config/lang";
import Swal from "sweetalert2";
import { setPhone, setUserName } from "../../../../redux/actions/language";
import { useDrawerTransition } from "../../../../context/drawerProvider";
import { useLocation } from "react-router-dom";
import { useProfileTab } from "../../ProfileTabContext";

//job portal, Referensi, Job Fair, Website SOPRA, Sosial Media | darimana anda menpatkan informasi mengenai SOPRA?

const GeneralQuestionsForm = ({ setIsFading, profileData, setprofileData, updatePercentage, profileCompletion }) => {
  const { lang } = useSelector((state) => state.globalReducer);
  const { currentTabIndex, setCurrentTabIndex } = useProfileTab();
  const location = useLocation();
  const { jobID } = location.state || {};
  const { startTransition } = useDrawerTransition();
  const applicantID = localStorage?.getItem("applicantID");
  const userToken = localStorage?.getItem('authToken') || '';
  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(false);
  const [otherInformationSource, setotherInformationSource] = useState('');

  const [isCheckboxDisabled, setisCheckboxDisabled] = useState(false);
  const [isLoading, setisLoading] = useState('');

  const [initAnswers, setinitAnswers] = useState({
    otherInfoID: 0,
    applicantID: 0,
    expectedSalary: 0,
    availabilityToStart: "",
    appliedBeforeAtSopra: "",
    appliedBeforeExplanation: "",
    hasRelativeAtSopra: "",
    relativeAtSopraExplanation: "",
    agreesToContactReferences: "",
    readyForShiftWork: "",
    readyForOutOfTownAssignments: "",
    readyForOutOfTownPlacement: "",
    hasSeriousIllnessOrInjury: "",
    seriousIllnessOrInjuryExplanation: "",
    hasPoliceRecord: "",
    policeRecordExplanation: "",
    hasPermanentPhysicalImpairment: "",
    physicalImpairmentExplanation: "",
    conflictOfInterest: "",
    conflictOfInterestDetails: "",
    sourceOfInformation: ''
  }
  );



  const loadApplicantInfo = async () => {
    loadData({
      url: `ApplicantOtherInfo`,
      params: [{ title: "filter", value: `applicant:${applicantID}` }],
      userToken,
    }).then(async (res) => {
      if (res?.data) {
        const resData = res.data[0];
        setinitAnswers(resData || {
          otherInfoID: 0,
          applicantID: 0,
          expectedSalary: 0,
          availabilityToStart: "",
          appliedBeforeAtSopra: "",
          appliedBeforeExplanation: "",
          hasRelativeAtSopra: "",
          relativeAtSopraExplanation: "",
          agreesToContactReferences: "",
          readyForShiftWork: "",
          readyForOutOfTownAssignments: "",
          readyForOutOfTownPlacement: "",
          hasSeriousIllnessOrInjury: "",
          seriousIllnessOrInjuryExplanation: "",
          hasPoliceRecord: "",
          policeRecordExplanation: "",
          hasPermanentPhysicalImpairment: "",
          physicalImpairmentExplanation: "",
          conflictOfInterest: "",
          conflictOfInterestDetails: "",
          sourceOfInformation: ''
        });
        if (!['Social Media', 'Job Fair', 'Job Portal', 'Website SOPRA', 'Reference'].includes(resData?.sourceOfInformation)) {
          setotherInformationSource(resData?.sourceOfInformation)
        }
      }
    });
  };

  useEffect(() => {
    loadApplicantInfo()
    setisCheckboxDisabled(profileData?.consentSignedAt !== null && profileData?.consentSignedAt !== undefined);
  }, [])

  const isFormReady = () => {
    const a = initAnswers;
    const missing = [];

    const isEmpty = (v) => v === "" || v === null || v === undefined;

    // Required fields
    if (isEmpty(a.expectedSalary)) missing.push("expectedSalary");
    if (isEmpty(a.availabilityToStart)) missing.push("availabilityToStart");
    if (isEmpty(a.appliedBeforeAtSopra)) missing.push("appliedBeforeAtSopra");
    if (isEmpty(a.hasRelativeAtSopra)) missing.push("hasRelativeAtSopra");
    if (isEmpty(a.agreesToContactReferences)) missing.push("agreesToContactReferences");
    if (isEmpty(a.readyForShiftWork)) missing.push("readyForShiftWork");
    if (isEmpty(a.readyForOutOfTownAssignments)) missing.push("readyForOutOfTownAssignments");
    if (isEmpty(a.readyForOutOfTownPlacement)) missing.push("readyForOutOfTownPlacement");
    if (isEmpty(a.hasSeriousIllnessOrInjury)) missing.push("hasSeriousIllnessOrInjury");
    if (isEmpty(a.hasPoliceRecord)) missing.push("hasPoliceRecord");
    if (isEmpty(a.hasPermanentPhysicalImpairment)) missing.push("hasPermanentPhysicalImpairment");
    if (isEmpty(a.conflictOfInterest)) missing.push("conflictOfInterest");
    if (isEmpty(profileData.consentSignedAt)) missing.push("consentSignedAt");
    if ((a.sourceOfInformation === 'Other' || !a.sourceOfInformation) && isEmpty(otherInformationSource)) missing.push('sourceOfInformation2')

    if (a.appliedBeforeAtSopra === true && isEmpty(a.appliedBeforeExplanation))
      missing.push("appliedBeforeExplanation");
    if (a.hasRelativeAtSopra === true && isEmpty(a.relativeAtSopraExplanation))
      missing.push("relativeAtSopraExplanation");
    if (a.hasSeriousIllnessOrInjury === true && isEmpty(a.seriousIllnessOrInjuryExplanation))
      missing.push("seriousIllnessOrInjuryExplanation");
    if (a.hasPoliceRecord === true && isEmpty(a.policeRecordExplanation))
      missing.push("policeRecordExplanation");
    if (a.hasPermanentPhysicalImpairment === true && isEmpty(a.physicalImpairmentExplanation))
      missing.push("physicalImpairmentExplanation");
    if (a.conflictOfInterest === true && isEmpty(a.conflictOfInterestDetails))
      missing.push("conflictOfInterestDetails");

    return missing.length === 0;
  };


  const showAlert = (value) => {
    Swal.fire({
      title: 'Success!',
      text: value,
      icon: 'success',
      timer: 3000,
      showConfirmButton: false,
      customClass: {
        popup: 'my-custom-popup'
      }
    });
  };

  const saveData = async () => {
    setisLoading(true);
    if (initAnswers?.otherInfoID) {
      const response = await updateData({
        url: "ApplicantOtherInfo",
        userToken,
        reqBody: {
          otherInfoID: initAnswers?.otherInfoID,
          applicantID: applicantID,
          expectedSalary: initAnswers?.expectedSalary,
          availabilityToStart: initAnswers?.availabilityToStart,
          appliedBeforeAtSopra: initAnswers?.appliedBeforeAtSopra,
          appliedBeforeExplanation: initAnswers?.appliedBeforeExplanation,
          hasRelativeAtSopra: initAnswers?.hasRelativeAtSopra,
          relativeAtSopraExplanation: initAnswers?.relativeAtSopraExplanation,
          agreesToContactReferences: initAnswers?.agreesToContactReferences,
          readyForShiftWork: initAnswers?.readyForShiftWork,
          readyForOutOfTownAssignments: initAnswers?.readyForOutOfTownAssignments,
          readyForOutOfTownPlacement: initAnswers?.readyForOutOfTownPlacement,
          hasSeriousIllnessOrInjury: initAnswers?.hasSeriousIllnessOrInjury,
          seriousIllnessOrInjuryExplanation: initAnswers?.seriousIllnessOrInjuryExplanation,
          hasPoliceRecord: initAnswers?.hasPoliceRecord,
          policeRecordExplanation: initAnswers?.policeRecordExplanation,
          hasPermanentPhysicalImpairment: initAnswers?.hasPermanentPhysicalImpairment,
          physicalImpairmentExplanation: initAnswers?.physicalImpairmentExplanation,
          conflictOfInterest: initAnswers?.conflictOfInterest,
          conflictOfInterestDetails: initAnswers?.conflictOfInterestDetails,
          sourceOfInformation: initAnswers.sourceOfInformation === 'Other' ? otherInformationSource : (initAnswers.sourceOfInformation || otherInformationSource)
        }
      });
      if (response) {
        await updateData({
          url: 'Applicants',
          userToken,
          reqBody: profileData,
        }).then(res => {
          if (res?.data) {
            const resData = res?.data;
            setisCheckboxDisabled(true)
            dispatch(setUserName(resData.fullName));
            dispatch(setPhone(resData.mobilePhoneNumber));
            updatePercentage(10)
            setIsEdit(false)
            showAlert(Lang(lang, 'success_to_send'))
            loadApplicantInfo()
            setisLoading(false);

            if (jobID) {
              setTimeout(() => {
                startTransition(`/${lang}/portal`, { jobID: jobID });
              }, 3000);
            }
          }
        })
      }
    } else {
      const response = await addData({
        url: "ApplicantOtherInfo",
        userToken,
        reqBody: {
          applicantID: applicantID,
          expectedSalary: initAnswers?.expectedSalary,
          availabilityToStart: initAnswers?.availabilityToStart,
          appliedBeforeAtSopra: initAnswers?.appliedBeforeAtSopra,
          appliedBeforeExplanation: initAnswers?.appliedBeforeExplanation,
          hasRelativeAtSopra: initAnswers?.hasRelativeAtSopra,
          relativeAtSopraExplanation: initAnswers?.relativeAtSopraExplanation,
          agreesToContactReferences: initAnswers?.agreesToContactReferences,
          readyForShiftWork: initAnswers?.readyForShiftWork,
          readyForOutOfTownAssignments: initAnswers?.readyForOutOfTownAssignments,
          readyForOutOfTownPlacement: initAnswers?.readyForOutOfTownPlacement,
          hasSeriousIllnessOrInjury: initAnswers?.hasSeriousIllnessOrInjury,
          seriousIllnessOrInjuryExplanation: initAnswers?.seriousIllnessOrInjuryExplanation,
          hasPoliceRecord: initAnswers?.hasPoliceRecord,
          policeRecordExplanation: initAnswers?.policeRecordExplanation,
          hasPermanentPhysicalImpairment: initAnswers?.hasPermanentPhysicalImpairment,
          physicalImpairmentExplanation: initAnswers?.physicalImpairmentExplanation,
          conflictOfInterest: initAnswers?.conflictOfInterest,
          conflictOfInterestDetails: initAnswers?.conflictOfInterestDetails,
          sourceOfInformation: initAnswers.sourceOfInformation === 'Other' ? otherInformationSource : (initAnswers.sourceOfInformation || otherInformationSource)
        }
      });
      if (response) {
        await updateData({
          url: 'Applicants',
          userToken,
          reqBody: profileData,
        }).then(res => {
          if (res?.data) {
            const resData = res?.data;
            setisCheckboxDisabled(true)
            setprofileData(resData)
            setIsEdit(false)
            dispatch(setUserName(resData.fullName));
            dispatch(setPhone(resData.mobilePhoneNumber));
            loadApplicantInfo()
            setisLoading(false);
            updatePercentage(10);

            showAlert(Lang(lang, 'success_to_send'));

            if (jobID) {
              setTimeout(() => {
                startTransition(`/${lang}/portal`, { jobID: jobID });
              }, 3000);
            }
          }
        })
      }
    }
  }


  const handleChange = (field, value) => {
    setinitAnswers(prevAnswers => ({
      ...prevAnswers,
      [field]: value,
    }));
  };
  return (
    <div>

      <div className="mt-4 bg-white p-6 rounded-xl shadow-[0px_1px_2px_rgba(0,0,0,0.05)]">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-blue-700 font-medium md:text-[20px] text-[17px] flex items-center space-x-2 cursor-pointer">
              <img src={"/asset/icon/general_questions.svg"} className="w-[16px] mr-1" />
              <span>{Lang(lang, 'general_questions')}</span>
            </h2>
          </div>
          {!isEdit && (
            <button
              onClick={() => setIsEdit(true)}
              className="flex border border-gray-300 rounded-full px-5 py-2 text-sm text-white bg-red-500 hover:bg-red-600"
            >
              <img src={"/asset/icon/edit.svg"} className="w-[16px] mr-1" />
              Edit
            </button>
          )}
        </div>

        <form className="space-y-6 text-sm">
          <div className="border border-gray-200 rounded-xl p-4">
            <p className="mb-2">
              1. {Lang(lang, 'q1')}<span className="text-red-500">*</span>
            </p>
            <div className="flex items-center space-x-6 mb-2">
              <span className="">{Lang(lang, 'answer')}:</span>
              <label className="flex items-center space-x-1">
                <input
                  disabled={!isEdit}
                  type="radio"
                  name="appliedBeforeAtSopra"
                  checked={initAnswers?.appliedBeforeAtSopra === true}
                  onChange={() => handleChange("appliedBeforeAtSopra", true)}
                />
                <span>{Lang(lang, 'ever')}</span>
              </label>
              <label className="flex items-center space-x-1">
                <input
                  disabled={!isEdit}
                  type="radio"
                  name="q1"
                  checked={initAnswers?.appliedBeforeAtSopra === false}
                  onChange={() => handleChange("appliedBeforeAtSopra", false)}
                />
                <span>{Lang(lang, 'never')}</span>
              </label>
            </div>
            {initAnswers?.appliedBeforeAtSopra && (
              <input
                disabled={!isEdit}
                type="text"
                value={initAnswers?.appliedBeforeExplanation}
                onChange={(e) => handleChange("appliedBeforeExplanation", e.target.value)}
                className={(isEdit ? 'bg-white' : 'bg-gray-100') + " w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                placeholder="Jelaskan..."
              />
            )}
          </div>

          <div className="border border-gray-200 rounded-xl p-4">
            <p className="mb-2">
              2. {Lang(lang, 'q2')}<span className="text-red-500">*</span>
            </p>
            <div className="flex items-center space-x-6 mb-2">
              <span className="">{Lang(lang, 'answer')}:</span>
              <label className="flex items-center space-x-1">
                <input
                  disabled={!isEdit}
                  type="radio"
                  name="hasRelativeAtSopra"
                  checked={initAnswers?.hasRelativeAtSopra === true}
                  onChange={() => handleChange("hasRelativeAtSopra", true)}
                />
                <span>{Lang(lang, 'yes')}</span>
              </label>
              <label className="flex items-center space-x-1">
                <input
                  disabled={!isEdit}
                  type="radio"
                  name="hasRelativeAtSopra"
                  checked={initAnswers?.hasRelativeAtSopra === false}
                  onChange={() => handleChange("hasRelativeAtSopra", false)}
                />
                <span>{Lang(lang, 'no')}</span>
              </label>
            </div>
            {initAnswers?.hasRelativeAtSopra && (
              <input
                disabled={!isEdit}
                type="text"
                value={initAnswers?.relativeAtSopraExplanation}
                onChange={(e) => handleChange("relativeAtSopraExplanation", e.target.value)}
                className={(isEdit ? 'bg-white' : 'bg-gray-100') + " w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                placeholder="Jelaskan..."
              />
            )}
          </div>

          <div className="border border-gray-200 rounded-xl p-4">
            <p className="mb-2">3. {Lang(lang, 'q3')}<span className="text-red-500">*</span></p>
            <div className="flex items-center space-x-6">
              <span className="">{Lang(lang, 'answer')}:</span>
              <label className="flex items-center space-x-1">
                <input
                  disabled={!isEdit}
                  type="radio"
                  name={`agreesToContactReferences`}
                  checked={initAnswers?.agreesToContactReferences === true}
                  onChange={() => handleChange('agreesToContactReferences', true)}
                />
                <span>{Lang(lang, 'willing')}</span>
              </label>
              <label className="flex items-center space-x-1">
                <input
                  disabled={!isEdit}
                  type="radio"
                  name={`agreesToContactReferences`}
                  checked={initAnswers?.agreesToContactReferences === false}
                  onChange={() => handleChange('agreesToContactReferences', false)}
                />
                <span>{Lang(lang, 'not_willing')}</span>
              </label>
            </div>
          </div>

          <div className="border border-gray-200 rounded-xl p-4">
            <p className="mb-2">4. {Lang(lang, 'q4')}<span className="text-red-500">*</span></p>
            <div className="flex items-center space-x-6">
              <span className="">{Lang(lang, 'answer')}:</span>
              <label className="flex items-center space-x-1">
                <input
                  disabled={!isEdit}
                  type="radio"
                  name={`readyForShiftWork`}
                  checked={initAnswers?.readyForShiftWork === true}
                  onChange={() => handleChange('readyForShiftWork', true)}
                />
                <span>{Lang(lang, 'willing')}</span>
              </label>
              <label className="flex items-center space-x-1">
                <input
                  disabled={!isEdit}
                  type="radio"
                  name={`readyForShiftWork`}
                  checked={initAnswers?.readyForShiftWork === false}
                  onChange={() => handleChange('readyForShiftWork', false)}
                />
                <span>{Lang(lang, 'not_willing')}</span>
              </label>
            </div>
          </div>

          <div className="border border-gray-200 rounded-xl p-4">
            <p className="mb-2">5. {Lang(lang, 'q5')}<span className="text-red-500">*</span></p>
            <div className="flex items-center space-x-6">
              <span className="">{Lang(lang, 'answer')}:</span>
              <label className="flex items-center space-x-1">
                <input
                  disabled={!isEdit}
                  type="radio"
                  name={`readyForOutOfTownAssignments`}
                  checked={initAnswers?.readyForOutOfTownAssignments === true}
                  onChange={() => handleChange('readyForOutOfTownAssignments', true)}
                />
                <span>{Lang(lang, 'willing')}</span>
              </label>
              <label className="flex items-center space-x-1">
                <input
                  disabled={!isEdit}
                  type="radio"
                  name={`readyForOutOfTownAssignments`}
                  checked={initAnswers?.readyForOutOfTownAssignments === false}
                  onChange={() => handleChange('readyForOutOfTownAssignments', false)}
                />
                <span>{Lang(lang, 'not_willing')}</span>
              </label>
            </div>
          </div>
          <div className="border border-gray-200 rounded-xl p-4">
            <p className="mb-2">6. {Lang(lang, 'q6')}<span className="text-red-500">*</span></p>
            <div className="flex items-center space-x-6">
              <span className="">{Lang(lang, 'answer')}:</span>
              <label className="flex items-center space-x-1">
                <input
                  disabled={!isEdit}
                  type="radio"
                  name={`readyForOutOfTownPlacement`}
                  checked={initAnswers?.readyForOutOfTownPlacement === true}
                  onChange={() => handleChange('readyForOutOfTownPlacement', true)}
                />
                <span>{Lang(lang, 'willing')}</span>
              </label>
              <label className="flex items-center space-x-1">
                <input
                  disabled={!isEdit}
                  type="radio"
                  name={`readyForOutOfTownPlacement`}
                  checked={initAnswers?.readyForOutOfTownPlacement === false}
                  onChange={() => handleChange('readyForOutOfTownPlacement', false)}
                />
                <span>{Lang(lang, 'not_willing')}</span>
              </label>
            </div>
          </div>

          <div className="border border-gray-200 rounded-xl p-4">
            <p className="mb-2">
              7. {Lang(lang, 'q7')}<span className="text-red-500">*</span>
            </p>
            <div className="flex items-center space-x-6 mb-2">
              <span className="">{Lang(lang, 'answer')}:</span>
              <label className="flex items-center space-x-1">
                <input
                  disabled={!isEdit}
                  type="radio"
                  name="hasSeriousIllnessOrInjury"
                  checked={initAnswers?.hasSeriousIllnessOrInjury === true}
                  onChange={() => handleChange("hasSeriousIllnessOrInjury", true)}
                />
                <span>{Lang(lang, 'ever')}</span>
              </label>
              <label className="flex items-center space-x-1">
                <input
                  disabled={!isEdit}
                  type="radio"
                  name="hasSeriousIllnessOrInjury"
                  checked={initAnswers?.hasSeriousIllnessOrInjury === false}
                  onChange={() => handleChange("hasSeriousIllnessOrInjury", false)}
                />
                <span>{Lang(lang, 'never')}</span>
              </label>
            </div>
            {initAnswers?.hasSeriousIllnessOrInjury && (
              <input
                disabled={!isEdit}
                type="text"
                value={initAnswers?.seriousIllnessOrInjuryExplanation}
                onChange={(e) => handleChange("seriousIllnessOrInjuryExplanation", e.target.value)}
                className={(isEdit ? 'bg-white' : 'bg-gray-100') + " w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                placeholder="Jelaskan..."
              />
            )}
          </div>


          <div className="border border-gray-200 rounded-xl p-4">
            <p className="mb-2">
              8. {Lang(lang, 'q8')}<span className="text-red-500">*</span>
            </p>
            <div className="flex items-center space-x-6 mb-2">
              <span className="">{Lang(lang, 'answer')}:</span>
              <label className="flex items-center space-x-1">
                <input
                  disabled={!isEdit}
                  type="radio"
                  name="hasPoliceRecord"
                  checked={initAnswers?.hasPoliceRecord === true}
                  onChange={() => handleChange("hasPoliceRecord", true)}
                />
                <span>{Lang(lang, 'ever')}</span>
              </label>
              <label className="flex items-center space-x-1">
                <input
                  disabled={!isEdit}
                  type="radio"
                  name="hasPoliceRecord"
                  checked={initAnswers?.hasPoliceRecord === false}
                  onChange={() => handleChange("hasPoliceRecord", false)}
                />
                <span>{Lang(lang, 'never')}</span>
              </label>
            </div>
            {initAnswers?.hasPoliceRecord && (
              <input
                disabled={!isEdit}
                type="text"
                value={initAnswers?.policeRecordExplanation}
                onChange={(e) => handleChange("policeRecordExplanation", e.target.value)}
                className={(isEdit ? 'bg-white' : 'bg-gray-100') + " w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                placeholder="Jelaskan..."
              />
            )}
          </div>

          <div className="border border-gray-200 rounded-xl p-4">
            <p className="mb-2">
              9. {Lang(lang, 'q9')}<span className="text-red-500">*</span>
            </p>
            <div className="flex items-center space-x-6 mb-2">
              <span className="">{Lang(lang, 'answer')}:</span>
              <label className="flex items-center space-x-1">
                <input
                  disabled={!isEdit}
                  type="radio"
                  name="hasPermanentPhysicalImpairment"
                  checked={initAnswers?.hasPermanentPhysicalImpairment === true}
                  onChange={() => handleChange("hasPermanentPhysicalImpairment", true)}
                />
                <span>{Lang(lang, 'yes')}</span>
              </label>
              <label className="flex items-center space-x-1">
                <input
                  disabled={!isEdit}
                  type="radio"
                  name="hasPermanentPhysicalImpairment"
                  checked={initAnswers?.hasPermanentPhysicalImpairment === false}
                  onChange={() => handleChange("hasPermanentPhysicalImpairment", false)}
                />
                <span>{Lang(lang, 'no')}</span>
              </label>
            </div>
            {initAnswers?.hasPermanentPhysicalImpairment && (
              <input
                disabled={!isEdit}
                type="text"
                value={initAnswers?.physicalImpairmentExplanation}
                onChange={(e) => handleChange("physicalImpairmentExplanation", e.target.value)}
                className={(isEdit ? 'bg-white' : 'bg-gray-100') + " w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                placeholder="Jelaskan..."
              />
            )}
          </div>

          <div className="border border-gray-200 rounded-xl p-4">
            <p className="mb-2">
              10. {Lang(lang, 'q10')}<span className="text-red-500">*</span>
            </p>
            <div className="flex items-center space-x-6 mb-2">
              <span className="">{Lang(lang, 'answer')}:</span>
              <label className="flex items-center space-x-1">
                <input
                  disabled={!isEdit}
                  type="radio"
                  name="q2"
                  checked={initAnswers?.conflictOfInterest === true}
                  onChange={() => handleChange("conflictOfInterest", true)}
                />
                <span>{Lang(lang, 'yes')}</span>
              </label>
              <label className="flex items-center space-x-1">
                <input
                  disabled={!isEdit}
                  type="radio"
                  name="q2"
                  checked={initAnswers?.conflictOfInterest === false}
                  onChange={() => handleChange("conflictOfInterest", false)}
                />
                <span>{Lang(lang, 'no')}</span>
              </label>
            </div>
            {initAnswers?.conflictOfInterest && (
              <input
                disabled={!isEdit}
                type="text"
                value={initAnswers?.conflictOfInterestDetails}
                onChange={(e) => handleChange("conflictOfInterestDetails", e.target.value)}
                className={(isEdit ? 'bg-white' : 'bg-gray-100') + " w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                placeholder="Jelaskan..."
              />
            )}
          </div>

          <div className="border border-gray-200 rounded-xl p-4">
            <p className="mb-2">11. {Lang(lang, 'q11')}<span className="text-red-500">*</span></p>
            <div className="flex flex-row items-center space-x-6">
              <span className="">{Lang(lang, 'answer')}:</span>
              <div className="relative md:w-[200px] w-full">
                <select
                  disabled={!isEdit}
                  value={['Social Media', 'Job Fair', 'Job Portal', 'Website SOPRA', 'Reference'].includes(initAnswers?.sourceOfInformation) ? initAnswers?.sourceOfInformation : 'Other'}
                  onChange={(e) => {
                    handleChange('sourceOfInformation', e.target.value)
                  }}
                  className={"appearance-none w-full rounded-full border border-gray-200 px-4 py-2 h-[60px] " + (isEdit ? 'bg-white' : 'bg-gray-100')}
                >
                  <option value="" disabled>
                    -- {Lang(lang, 'select_source')} --
                  </option>
                  <option value="Social Media">Sosial Media</option>
                  <option value="Job Fair">Job Fair</option>
                  <option value="Job Portal">Job Portal</option>
                  <option value="Website SOPRA">Website SOPRA</option>
                  <option value="Reference">{Lang(lang, 'reference')}</option>
                  <option value="SGTS">SGTS</option>
                  <option value="SGTC">SGTC</option>
                  <option value="Other">{Lang(lang, 'other')}</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-500">
                  ▼
                </div>
              </div>
            </div>
            {(initAnswers?.sourceOfInformation === 'Other' || !(['Social Media', 'Job Fair', 'Job Portal', 'Website SOPRA', 'Reference'].includes(initAnswers?.sourceOfInformation))) && (
              <input
                disabled={!isEdit}
                type="text"
                value={otherInformationSource}
                onChange={(e) => setotherInformationSource(e.target.value)}
                className={(isEdit ? 'bg-white' : 'bg-gray-100') + " w-full rounded-full border border-gray-200 px-4 py-2 h-[60px] mt-5"}
                placeholder="Jelaskan..."
              />
            )}
          </div>

          <div className="border border-gray-200 rounded-xl p-4">
            <p className="mb-2">12. {Lang(lang, 'q12')}<span className="text-red-500">*</span></p>
            <div className="flex flex-row items-center space-x-6">
              <span className="">{Lang(lang, 'answer')}:</span>
              <div className="relative md:w-[200px] w-full">
                <select
                  disabled={!isEdit}
                  value={initAnswers?.availabilityToStart}
                  onChange={(e) => handleChange('availabilityToStart', e.target.value)}
                  className={"appearance-none w-full rounded-full border border-gray-200 px-4 py-2 h-[60px] " + (isEdit ? 'bg-white' : 'bg-gray-100')}
                >
                  <option value="" disabled>
                    -- {Lang(lang, 'choose_availability')} --
                  </option>
                  <option value="Secepatnya">{Lang(lang, 'asap')}</option>
                  <option value="2 Minggu">{Lang(lang, 'two_weeks')}</option>
                  <option value="4 Minggu">{Lang(lang, 'four_weeks')}</option>
                  <option value="8 Minggu">{Lang(lang, 'eight_weeks')}</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-500">
                  ▼
                </div>
              </div>
            </div>
          </div>

          <div className="border border-gray-200 rounded-xl p-4">
            <p className="mb-2">
              13. {Lang(lang, 'q13')}<span className="text-red-500">*</span>
            </p>
            <div className="flex flex-row items-center space-x-6">
              <span className="">{Lang(lang, 'answer')}:</span>
              <input
                disabled={!isEdit}
                type={isEdit ? "number" : "text"}
                value={isEdit
                  ? initAnswers?.expectedSalary || ""
                  : initAnswers?.expectedSalary
                    ? new Intl.NumberFormat("id-ID", {
                      style: "currency",
                      currency: "IDR",
                      minimumFractionDigits: 0,
                    }).format(initAnswers?.expectedSalary)
                    : ""
                }
                onChange={(e) => {
                  const numericValue = e.target.value.replace(/[^0-9]/g, '');
                  e.target.value = numericValue;
                  handleChange("expectedSalary", e.target.value);
                }}
                className={(isEdit ? 'bg-white' : 'bg-gray-100') + " w-full rounded-full border border-gray-200 px-4 py-2 h-[60px] appearance-none"}
                placeholder="Rp..."
              />
            </div>
          </div>
        </form>

        <div className="flex justify-between items-center text-sm mb-6 w-full mt-5">
          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              disabled={!isEdit || isCheckboxDisabled}
              className="form-checkbox text-red-500"
              checked={!!profileData.consentSignedAt}
              onChange={() => {
                const localIso = new Date()
                  .toLocaleString('sv-SE', { hour12: false })
                  .replace(' ', 'T');
                setprofileData({
                  ...profileData,
                  consentSignedAt: profileData.consentSignedAt
                    ? null
                    : localIso,
                });
              }}
            />
            <span className="text-gray-700">{Lang(lang, 'agree_to_contact_references')}<span className="text-red-500">*</span></span>
          </label>
        </div>

        {!isFormReady() && <div className="flex justify-end w-full">
          <p className="text-red-500 text-xs mt-1 mr-0">{Lang(lang, 'required_error')}</p>
        </div>}
      </div>

      {isEdit ? <div className="flex space-x-2 mt-3 justify-end w-full bg-white shadow-[0px_1px_2px_rgba(0,0,0,0.05)] p-3 rounded-xl sticky bottom-3">
        <button
          type="button"
          className="border border-gray-300 rounded-full px-4 py-1 text-sm hover:bg-gray-100"
          onClick={() => {
            setIsFading(true);
            setTimeout(() => {
              setCurrentTabIndex(currentTabIndex - 1);
              setIsFading(false);
            }, 200);
          }}
        >
          {Lang(lang, 'previous')}
        </button>
        <button
          type="submit"
          onClick={() => {
            if (isFormReady() && !isLoading) {
              saveData()
            }
          }}
          className={!isFormReady() ? "border border-gray-300 rounded-full px-4 py-1 text-sm hover:bg-gray-100" : "bg-red-500 hover:bg-red-600 text-white rounded-full px-4 py-1 text-sm"}
        >
          {isLoading ? <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto" /> : Lang(lang, 'submit')}
        </button>
      </div> : <div className="flex space-x-2 mt-3 justify-end w-full bg-white shadow-[0px_1px_2px_rgba(0,0,0,0.05)] p-3 rounded-xl sticky bottom-3">
        <button
          type="button"
          className="border border-gray-300 rounded-full px-4 py-1 text-sm hover:bg-gray-100"
          onClick={() => {
            setIsFading(true);
            setTimeout(() => {
              setCurrentTabIndex(currentTabIndex - 1);
              setIsFading(false);
            }, 200);
          }}
        >
          {Lang(lang, 'previous')}
        </button>
      </div>}
    </div>
  );
};

export default GeneralQuestionsForm;
